/* unplugin-vue-components disabled */import { render } from "./ordinary.vue?vue&type=template&id=11bf633f&scoped=true"
import script from "./ordinary.vue?vue&type=script&lang=js"
export * from "./ordinary.vue?vue&type=script&lang=js"

import "./ordinary.vue?vue&type=style&index=0&id=11bf633f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bf633f"]])

export default __exports__